import React from 'react';
import { createRoot } from 'react-dom/client';
import FooterWrapper from './FooterWrapper';
document.addEventListener('DOMContentLoaded', () => {
    var _a, _b, _c, _d;
    const footerWrapper = document.querySelector('.js-footer-wrapper');
    if (!footerWrapper) {
        return;
    }
    const footerSections = JSON.parse((_a = footerWrapper.dataset.footerSections) !== null && _a !== void 0 ? _a : '[]');
    const footerBottomLinks = JSON.parse((_b = footerWrapper.dataset.footerBottomLinks) !== null && _b !== void 0 ? _b : '[]');
    const root = createRoot(footerWrapper);
    root.render(
    // @ts-ignore
    React.createElement(React.StrictMode, null,
        React.createElement(FooterWrapper, { fixed: false, title: (_c = footerWrapper.dataset.footerTitle) !== null && _c !== void 0 ? _c : '', footerSections: footerSections, footerBottomLinks: footerBottomLinks, toTopButtonLabel: (_d = footerWrapper.dataset.toTopLabel) !== null && _d !== void 0 ? _d : '' })));
});
